import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { CustomEmailConfirmContainer } from "./components/emailConfirmModal";
import { confirmSaga } from "./sagas/confirmSaga";
import { sendEmailSaga } from "./sagas/sendEmailSaga";

const emailModule = (): Module => ({
	id: "moduleEmail",
	views: () => viewComponentProvider,
	sagas: () => [sendEmailSaga, confirmSaga]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	CustomEmailConfirmContainer
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default emailModule;
